import { registerFlow } from '../../../core/flow-register';
import { makeFlow } from '..';
import { IRAAccountTypes } from '../loaders';

registerFlow(
  makeFlow('roth-ira', {
    toIRAAccountType: IRAAccountTypes.ROTH,
    fromIRAAccountType: IRAAccountTypes.ROTH
  })
);
